
export class NodeModelBase {
    public Name: string;
    public Children: Array<NodeModelBase>;
    public Visible: boolean;
    public Expanded: boolean;

    constructor(name: string, children: Array<NodeModelBase> = null) {
        this.Name = name;
        this.Children = children || [];
        this.Visible = true;
        this.Expanded = true;
    }

    hasChildren() {
        return this.Children.length > 0;
    }

    toggleNode() {
        for (var i = 0; i < this.Children.length; i++) {
            this.Children[i].Visible = !this.Children[i].Visible;
        }
        this.Expanded = !this.Expanded;
    }
}